import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import LoaderComponent from '../elements/LoaderComponent';

import { ContentContext,
         ConfigurationContext } from '../../context';

import TableTrivias from './../elements/DataTable/TableTrivias';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
    background-color: #fff;
  .actions{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    .bt_delete_single,
    .bt_edit_single,
    .bt_view_single{
      display: flex;
      font-size: 20px;
      color: ${props => `rgb(${props.pancolors.red})`};
      cursor: pointer;
      :hover{
        color: ${props => `rgb(${props.pancolors.black_overwhite})`};
      }
    }
    .bt_edit_single,
    .bt_view_single{
      margin-right: 10px;
      color: ${props => `rgb(${props.pancolors.dots})`};
      :hover{
        color: ${props => `rgb(${props.pancolors.black_overwhite})`};
      }
    }
  }
`

const TriviasTable = (props) => {

    const { t } = useTranslation();

    const { filters = null } = props;

    const { getTrivias,
            basicData,
            trivias, 
            setTrivias } = useContext(ContentContext);

    const { panColors,
            clientData } = useContext(ConfigurationContext);
            
    const [ headCells, 
            setHeadCells ] = useState([]);


    useEffect(() => {
        
        if(basicData){
  
          const _headCells = [];
          
          _headCells.push({ id: 'image',
                            numeric: false,
                            disablePadding: false,
                            label: "Imagen",
                            align: 'left', });

          _headCells.push({ id: 'name',
                            numeric: false,
                            disablePadding: false,
                            label: "Titulo",
                            align: 'left', });

          _headCells.push({ id: 'description',
                            numeric: false,
                            disablePadding: false,
                            label: "Descripción",
                            align: 'left', });

          _headCells.push({ id: 'segments',
                            numeric: false,
                            disablePadding: false,
                            label: "Segmentación",
                            align: 'left', });

          _headCells.push({ id: 'date_created',
                            numeric: false,
                            disablePadding: false,
                            label: "Creación",
                            align: 'left', });
          /*
          if((basicData.settings.store.section_list_columns.filter(col => col.id === 'name')).length){
                _headCells.push({ id: 'name',
                                  numeric: false,
                                  disablePadding: false,
                                  label: (basicData.settings.store.section_list_columns.filter(col => col.id === 'name'))[0].label,
                                  align: 'left', });
          }

          if((basicData.settings.store.section_list_columns.filter(col => col.id === 'code')).length){
                _headCells.push({ id: 'code',
                                  numeric: false,
                                  disablePadding: false,
                                  label: (basicData.settings.store.section_list_columns.filter(col => col.id === 'code'))[0].label,
                                  align: 'left', });
          }

          if((basicData.settings.store.section_list_columns.filter(col => col.id === 'region')).length){
                _headCells.push({ id: 'region',
                                  numeric: false,
                                  disablePadding: false,
                                  label: (basicData.settings.store.section_list_columns.filter(col => col.id === 'region'))[0].label,
                                  align: 'left', });
          }

          if((basicData.settings.store.section_list_columns.filter(col => col.id === 'area')).length){
                _headCells.push({ id: 'area',
                                  numeric: false,
                                  disablePadding: false,
                                  label: (basicData.settings.store.section_list_columns.filter(col => col.id === 'area'))[0].label,
                                  align: 'left', });
          }

          if((basicData.settings.store.section_list_columns.filter(col => col.id === 'cluster')).length){
                _headCells.push({ id: 'cluster',
                                  numeric: false,
                                  disablePadding: false,
                                  label: (basicData.settings.store.section_list_columns.filter(col => col.id === 'cluster'))[0].label,
                                  align: 'left', });
          }

          if((basicData.settings.store.section_list_columns.filter(col => col.id === 'address')).length){
                _headCells.push({ id: 'address',
                                  numeric: false,
                                  disablePadding: false,
                                  label: (basicData.settings.store.section_list_columns.filter(col => col.id === 'address'))[0].label,
                                  align: 'left', });
          }

          if((basicData.settings.store.section_list_columns.filter(col => col.id === 'format')).length){
                _headCells.push({ id: 'format',
                                  numeric: false,
                                  disablePadding: false,
                                  label: (basicData.settings.store.section_list_columns.filter(col => col.id === 'format'))[0].label,
                                  align: 'left', });
          }
          */

          _headCells.push({ id: '',
                            numeric: false,
                            disablePadding: false,
                            label: 'Acciones',
                            align: 'right',
                            sorteable: false, });

          setHeadCells(_headCells);
  
        }
        return () => {}
      }, [basicData])


    useEffect(() => {
        
        setTrivias(null);
        getTrivias(0, 25, filters);

    }, [filters])

    useEffect(() => {
        return () => {
            setTrivias(null);
        }
    }, [])
    
    return (
        <Wrapper pancolors={panColors}>
        
        
        {trivias == null || trivias === undefined ?

            <LoaderComponent />

        :
        trivias.games.length ?
            <TableTrivias
                headCells={headCells} 
                type={"trivias"}
                title={t("texts.Trivias")} 
                data={trivias.games} 
                getData={getTrivias}
                totalRows={trivias.total}
                filters={filters}
                settings={basicData.settings.store}
            />
            :
            <>{t("texts.No hay registros para mostrar")}</>
        }
        
        </Wrapper>
    );
}

export default TriviasTable;